import AlignHorizontalCenterRoundedIcon from "@mui/icons-material/AlignHorizontalCenterRounded"
import AlignHorizontalLeftRoundedIcon from "@mui/icons-material/AlignHorizontalLeftRounded"
import AlignHorizontalRightRoundedIcon from "@mui/icons-material/AlignHorizontalRightRounded"
import AlignVerticalBottomRoundedIcon from "@mui/icons-material/AlignVerticalBottomRounded"
import AlignVerticalCenterRoundedIcon from "@mui/icons-material/AlignVerticalCenterRounded"
import AlignVerticalTopRoundedIcon from "@mui/icons-material/AlignVerticalTopRounded"
import DensityMediumRoundedIcon from "@mui/icons-material/DensityMediumRounded"
import Box from "@mui/material/Box"
import { t } from "i18next"
import SegmentedButtonGroup, { SegmentT } from "../../../common/PropertyTools/SegmentedButtonGroup"

interface Props {
    onClick: (property: string, value: string) => void
    disabled?: boolean
    multiAlign?: boolean
    disabledDistribute?: boolean
}

/** Horizontal and vertical alignment (and distribution for a multiselection), Figma style. */
const Alignment = ({ onClick, disabled, multiAlign, disabledDistribute }: Props) => {
    const tooltip = (key: string) => t(`editor:size&positionSettings.alignTooltip.${key}`)

    const horizontal: SegmentT[] = [
        {
            title: tooltip("horizontalLeft"),
            icon: <AlignHorizontalLeftRoundedIcon fontSize="small" />,
            onClick: () => onClick("left", "horizontalLeft"),
            disabled,
        },
        {
            title: tooltip("horizontalCenter"),
            icon: <AlignHorizontalCenterRoundedIcon fontSize="small" />,
            onClick: () => onClick("left", "horizontalCenter"),
            disabled,
        },
        {
            title: tooltip("horizontalRight"),
            icon: <AlignHorizontalRightRoundedIcon fontSize="small" />,
            onClick: () => onClick("left", "horizontalRight"),
            disabled,
        },
    ]
    const vertical: SegmentT[] = [
        {
            title: tooltip("verticalTop"),
            icon: <AlignVerticalTopRoundedIcon fontSize="small" />,
            onClick: () => onClick("top", "verticalTop"),
            disabled,
        },
        {
            title: tooltip("verticalCenter"),
            icon: <AlignVerticalCenterRoundedIcon fontSize="small" />,
            onClick: () => onClick("top", "verticalCenter"),
            disabled,
        },
        {
            title: tooltip("verticalBottom"),
            icon: <AlignVerticalBottomRoundedIcon fontSize="small" />,
            onClick: () => onClick("top", "verticalBottom"),
            disabled,
        },
    ]
    const distribute: SegmentT[] = [
        {
            title: tooltip("verticallyDistribute"),
            icon: <DensityMediumRoundedIcon fontSize="small" />,
            onClick: () => onClick("top", "verticallyDistribute"),
            disabled: disabled || disabledDistribute,
        },
        {
            title: tooltip("horizontallyDistribute"),
            icon: <DensityMediumRoundedIcon fontSize="small" sx={{ rotate: "90deg" }} />,
            onClick: () => onClick("left", "horizontallyDistribute"),
            disabled: disabled || disabledDistribute,
        },
    ]

    return (
        <Box display="flex" gap={1} width="100%">
            <Box flex={3}>
                <SegmentedButtonGroup segments={horizontal} />
            </Box>
            <Box flex={3}>
                <SegmentedButtonGroup segments={vertical} />
            </Box>
            {multiAlign && (
                <Box flex={2}>
                    <SegmentedButtonGroup segments={distribute} />
                </Box>
            )}
        </Box>
    )
}

export default Alignment
